import { useActiveTheme } from '@/hooks/useActiveTheme';
import useCompanyCustomizations from '@/hooks/useCompanyCustomizations';
import useLoyaltyAccess from '@/hooks/useLoyaltyEnabled';
import { SideBarPropsType } from '@/models/globalModels';
import { useAppSelector } from '@/redux/hooks';

import CustomerAdvocacyBadges from '../customerAdvocay/Badges';
import CustomerAdvocacyPointSystem from '../customerAdvocay/PointSystem';
import LoyaltyTierPointSystem from '../loyalty/PointSystem';
import LoyaltyRecognitions from '../loyalty/Recognitions';

import Gate from './Gate';
import ReferredBy from './ReferredBy';
import SideBarMenu from './SideBarMenu';
import SideBarUserInfo from './SideBarUserInfo';

const SideBar = ({ itemActive, mobileSidebarToggler, setMobileSideBarToggler }: SideBarPropsType) => {
  const companyCustomizations = useCompanyCustomizations();
  const hasLoyaltyAccess = useLoyaltyAccess();
  const dashboardCustomization = companyCustomizations?.dashboard;
  const company = useAppSelector((state) => state.auth.companyAccount);
  const hasPortal3Access = company?.portal_v3_access;
  const { theme } = useActiveTheme();

  const clickCallback = () => {
    setMobileSideBarToggler && setMobileSideBarToggler(false);
  };

  return (
    <div className={`SideBar w-100 ${mobileSidebarToggler ? 'mobile-toggle' : ''}`} data-theme={theme}>
      <div className="container userInfo">
        <SideBarUserInfo />
      </div>

      <Gate allow="sidebar_point_system">
        {hasLoyaltyAccess && dashboardCustomization?.show_tier_progress && (
          <div className="container">{hasPortal3Access ? <LoyaltyTierPointSystem /> : <CustomerAdvocacyPointSystem />}</div>
        )}
      </Gate>

      <div className="container containerMenu p-0 mt-4">
        <SideBarMenu itemActive={itemActive} onClickCallback={clickCallback} />
      </div>

      <Gate allow="sidebar_referred_by">
        <div className="container mt-4">
          <ReferredBy />
        </div>
      </Gate>

      {hasLoyaltyAccess && dashboardCustomization?.show_badges_section && (
        <Gate allow="loyalty_badges">
          <div className="container mt-4 pb-4">{hasPortal3Access ? <LoyaltyRecognitions /> : <CustomerAdvocacyBadges />}</div>
        </Gate>
      )}
    </div>
  );
};

export default SideBar;
